<template>
    <div class="col-md-12 panel">
                <loading :active.sync="isLoading" color="#4c4a49" :is-full-page="false"></loading>
                <div class="row">
                    <div class="col-md-12">
                        <div class="panel">
                            <div class="panel-heading">
                                <div class="panel-title hidden-xs">
                                    <span class="glyphicon glyphicon-tasks"></span>Преподаватели <span
                                        id="instructor_name"></span></div>
                            </div>
                            <form v-on:submit.prevent="getReport" class="ng-pristine ng-valid">
                                <div class="panel-body ">
                                    <div class="col-md-4">
                                        <input type="date" v-model="filter.from" class="form-control"
                                               value="" placeholder="Начало периода" required="">
                                    </div>
                                    <div class="col-md-4">
                                        <input type="date" v-model="filter.to" class="form-control"
                                               value="" placeholder="Конец периода" required="">
                                    </div>

                                </div>
                                <div class="panel-footer">
                                    <button type="submit" class="btn btn-primary getstat"> Показать </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>

                <div class="section row" v-if="rows.length > 0">
                    <div class="col-md-12">
                        <div class="panel panel-visible">

                            <div class="panel-body pn">
                                <table class="table table-striped table-hover datatables table-fixed-header" cellspacing="0" width="100%">
                                    <thead>
                                    <tr>
                                        <th>Преподаватель</th>
                                        <th>Количество новичков</th>
                                        <th>Первых посещений</th>
                                        <th>Вернувшихся клиентов</th>
                                        <th>Коэффициент возврата</th>
                                        <th>Количество записей</th>
                                        <th>Количество часов</th>
                                        <th>Среднее количество людей в группе</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="(row, index) in rows" v-bind:key="index">
                                        <td>{{row.name}}</td>
                                        <td class="sum-cell">{{row.first}}</td>
                                        <td class="sum-cell">{{row.new}}</td>
                                        <td class="sum-cell">{{row.back}}</td>
                                        <td class="sum-cell">{{row.back_percent}}</td>
                                        <td class="sum-cell">{{row.order}}</td>
                                        <td class="sum-cell">{{row.hours | numberFormat(1, '.', ' ')}}</td>
                                        <td class="sum-cell">{{row.average_group}}</td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>

    </div>
</template>

<script>
    import Report from "../../classes/api/Report";
    import moment from 'moment';

    export default {
        components: {
            Loading: () => import('vue-loading-overlay'),
        },
        mounted() {
            this.getReport();
        },
        data() {
            return {
                isLoading: false,
                filter: {
                    from: moment().format('YYYY-MM-01'),
                    to: moment().format('YYYY-MM-DD'),
                },
                rows: [],
            };
        },
        methods: {
            async getReport() {
                this.isLoading = true;
                let response = await Report.getTrainerEfficiency(this.filter.from, this.filter.to);
                this.rows = response.data;
                this.isLoading = false;
            },
        },
        metaInfo() {
            return {
                title: 'Отчеты - эффективность преподавателей',
                meta: [
                    {vmid: 'description', name: 'description', content: ''},
                    {vmid: 'keywords', name: 'keywords', content: ''},
                ],
            };
        },
    }
</script>
